export const APP_ROUTES = {
  LOGIN: "/",
  HOME: "/dashboard",
  CHECKOUT: "/checkout",
  CONSULTDOCTOR: "/consultdoctor",
  DOCTORDETAILS: "/doctordetail",
  PRIVACYPOLICY: "/privacypolicy",
  TERMSOFUSE: "/termsofuse",
  REFUNDPOLICY: "/refundpolicy",
  // newly added routes from patient app
  MYAPPOINMENTS: "/myappointments",
  MYPROFILE: "/myprofile",
  FAMILYMEMBERS: "/familymembers",
  MEDICALRECORDS: "/medicalrecords",
  MEDICALHISTORY: "/medicalhistory",
  MYPRESCRIPTION: "/myprescription",
  MYVITALS: "/myvitals",
  MYREPORTS: "/myreports",
  MYLABREPORTS: "/mylabreports",
  PAYMENTS: "/payments",
  SETTINGS: "/settings",
  VIDEOCALL: "/videocall",
  LABPRSCRIPTION: "/sp/v1/l/:id",
  PHARMACYPRSCRIPTION: "/sp/v1/p/:id",
  LOGOUT: "/logout",
  PrescriptionTemplate: "/PrescriptionTemplate",
  FORGOTPASSWORD: "/forgotpassword",
  SHARECALLPATIENT: "/sharecallpatient",
  PHONEPEPAYMENT: "/phonepepayment/:transactionId",
  CARTPAGEPAYMENT: "/cartpagepayment/:transactionId",
  PHONEPEPAYMENT1: "/phonePeResponse1/paymentRedirectDetails/:status",
  HEALTHSUMMARY: "/healthsummary",
  PHRACCESS: "/PHR-ACCESS/:id",
  HOSPITALSERVICE: "/hospitalservice",
  MEDICINES: "/medicines",
  MEDICINECART: "/medicinecart",
  PRODUCTDETAILS: "/productdetails",
  LABTESTS: "/labtests",
  CHECKUP: "/checkup",
  CHECKUPALL: "/checkupall",
  TESTDETAILS: "/testdetails",
  TESTCART: "/testcart",
  CONSENT: "/consent",
  DASHBOARDNEW: "/dashboard",
  LOGCONSENT: "/logconsent",
  ORDERHISTORY: "/orderhistory",
  GIVECONSENT: "/v1/cons/",
  BOOKMEDICINE: "/bookmedicine",
  BOOKLABTEST: "/booklabtest",
  BOOKAPPOINTMENT: "/bookappointment",
  DOCTORDETAIL: "/doctorprofile",
  MYCART: "/mycart",
  MEDICINEDETAILS: "/medicinedetails",
  LABTESTDETAILS: "/labtestdetails",
  CART: "/cart",
  NOTIFICATION: "/notification",
  DEVICES: "/devices",
  //Direct Link Routes
  MOBILECONSENT: "/v1/cons/pat/",
  SHAREPRSCRIPTION: "/sp/v1",
  LABREPORTLINK: "/v1/ld",
  SHAREPAYMENTLINK: "/s/v1",
  SHARECALL: "/vc",
  HEALTHPLANS: "/healthplans",
  MEMBERSHIP: "/membership",
  JOINMEMBERSHIP: "/joinmembership",
  PATIENTMBERSHIP: "/patientmembership",
};
